import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';

import { OverlayService } from '../../../../floor-container/floor/item/overlay.service';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { FloorOption } from '../../elevators/elevators.model';

@Component({
  selector: 'sp-move-floor',
  templateUrl: './move-floor.component.html',
  styleUrls: ['./move-floor.component.scss'],
  standalone: false,
})
export class MoveFloorComponent implements OnInit, OnDestroy {
  data: FloorOption[];
  moveFloorFG: UntypedFormGroup;
  aboveBelowOptions: FloorOption[] = [
    { value: 'above', label: 'moreInfo.above' },
    { value: 'below', label: 'moreInfo.below' },
  ];
  emitOnDestroy = true;

  @Output() overlayEmit = new EventEmitter();

  constructor(
    private fb: UntypedFormBuilder,
    private overlayService: OverlayService
  ) {}

  ngOnInit() {
    this.data = this.overlayService.overlayDialogData;
    this.moveFloorFG = this.fb.group({
      aboveBelow: new UntypedFormControl('above'),
      floorIndex: new UntypedFormControl(this.data.length > 0 ? this.data[0].value : ''),
    });
  }

  ngOnDestroy(): void {
    // required by angular-l10n
    if (this.emitOnDestroy) {
      this.overlayEmit.emit(null);
    }
  }

  moveFloor() {
    this.emitOnDestroy = false;
    this.overlayEmit.emit(this.moveFloorFG.value);
    this.overlayService.disposeBox();
  }
}
